export type ArticleChapterSource={source_url:string|null;metadata?:{chapter_path?:unknown;source_mode?:unknown}};
const labels:Record<string,string>={
 "obra nova":"Obra nova","reabilitacao":"Reabilitação","espacos urbanos":"Espaços urbanos",
 "estruturas":"Estruturas","betao armado":"Betão armado","pilares":"Pilares","vigas":"Vigas","muros":"Muros",
 "fachadas divisoes e proteccoes":"Fachadas, divisões e proteções","alvenaria nao estrutural":"Alvenaria não estrutural",
 "pano interior para revestir em":"Pano interior para revestir",
 "isolamentos e impermeabilizacoes":"Isolamentos e impermeabilizações","isolamentos termicos":"Isolamentos térmicos",
 "sistemas etics de isolamento e":"Sistemas ETICS",
 "sistemas etics de isolamento e revestimento exterior de fachadas":"Sistemas ETICS",
 "etics":"Sistemas ETICS",
 "impermeabilizacoes":"Impermeabilizações","coberturas galerias e varandas":"Coberturas, galerias e varandas",
 "pinturas em paramentos interiores":"Pinturas interiores",
 "revestimentos":"Revestimentos","pinturas em paramentos exteriores":"Pinturas exteriores","tintas plasticas":"Tintas plásticas",
};
const modeLabels:Record<string,string>={obra_nova:"Obra nova",reabilitacao:"Reabilitação",espacos_urbanos:"Espaços urbanos"};
function sourceMode(article:ArticleChapterSource):string|null{
 const recorded=article.metadata?.source_mode;
 if(typeof recorded==="string" && modeLabels[recorded])return modeLabels[recorded];
 try{return article.source_url ? modeLabels[new URL(article.source_url).pathname.split("/").filter(Boolean)[0]] ?? null : null;}
 catch{return null;}
}
function canonicalLabel(segment:string):string {
 const key=segment.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLocaleLowerCase("pt-PT");
 return labels[key] ?? segment;
}
function isCypeSource(article:ArticleChapterSource):boolean {
 try{return Boolean(article.source_url && ["geradordeprecos.info","www.geradordeprecos.info"].includes(new URL(article.source_url).hostname));}
 catch{return false;}
}
function labelOf(segment:string):string {
 const clean=decodeURIComponent(segment).replaceAll("_"," ").replace(/\s+/g," ").trim().replace(/^[A-Z]{2,4}\s+/,"");
 return canonicalLabel(clean);
}
export function articleChapterPath(article:ArticleChapterSource):string[]{
 const explicit=article.metadata?.chapter_path;
 if(Array.isArray(explicit) && explicit.length>0 && explicit.length<=10
  && explicit.every(part=>typeof part==="string" && part.trim().length>0 && part.length<=200)){
  const path=explicit.map(part=>isCypeSource(article)?canonicalLabel(part.trim()):part.trim());
  const mode=sourceMode(article);
  return mode && !Object.values(modeLabels).includes(path[0]) ? [mode,...path] : path;
 }
 if(article.source_url){
  try{
   const url=new URL(article.source_url);
   const segments=url.pathname.split("/").filter(Boolean).slice(0,-1);
   const path=segments.map(labelOf).filter(Boolean);
   if(path.length)return path;
  }catch{/* Invalid addresses retain a usable internal chapter. */}
 }
 return ["Artigos internos"];
}
